import { render, staticRenderFns } from "./ApprovalResearch.vue?vue&type=template&id=6a758cc6&"
import script from "./ApprovalResearch.vue?vue&type=script&lang=js&"
export * from "./ApprovalResearch.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalResearch.vue?vue&type=style&index=0&id=6a758cc6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports